import React, { Component } from "react";
import { UPLOAD_ICON } from "../../../../../../../assets/js/image";
import "./Dropzone.css";

class Dropzone extends Component {
  constructor(props) {
    super(props);
    this.state = { hightlight: false };
    this.fileInputRef = React.createRef();
    this.fileBrowseRef = React.createRef();

    this.openFileDialog = this.openFileDialog.bind(this);
    this.onDragOver = this.onDragOver.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  openFileDialog() {
    if (this.props.disabled) return;
    this.fileInputRef.current.click();
  }

  onFilesAdded = (event) => {
    event.preventDefault();
    if (this.props.disabled) return;
    const files = event?.target?.files || [];

    if (this.props.onFilesAdded) {
      const array = this.fileListToArray(files);
      for (var i = 0; i < array.length; i++) {
        this.props.onFilesAdded(array[i]);
      }
    }
  }

  onDragOver(event) {
    event.preventDefault();
    if (this.props.disabled) return;
    this.setState({ hightlight: true });
  }

  onDragLeave(event) {
    this.setState({ hightlight: false });
  }

  onDrop(event) {
    event.preventDefault();
    if (this.props.disabled) return;
    const files = event.dataTransfer.files;
    if (this.props.onFilesAdded) {
      const array = this.fileListToArray(files);
      for (var i = 0; i < array.length; i++) {
        this.props.onFilesAdded(array[i]);
      }
    }
    this.setState({ hightlight: false });
  }

  fileListToArray(list) {
    const array = [];
    for (var i = 0; i < list.length; i++) {
      array.push(list.item(i));
    }
    return array;
  }

  render() {
    return (
      <div>
        <div
          className={`Dropzone ${this.state.hightlight ? "Highlight" : ""}`}
          onDragOver={this.onDragOver}
          onDragLeave={this.onDragLeave}
          onDrop={this.onDrop}
          onClick={this.openFileDialog}
          style={{ cursor: this.props.disabled ? "default" : "pointer" }}
        >
          <input
            ref={this.fileInputRef}
            className="FileInput"
            type="file"
            multiple
            onChange={(e) => {
              this.onFilesAdded(e);
              e.target.value = "";
            }}
          />
          <div className="icon_image_wrapper">
            <UPLOAD_ICON style="Icon_image" altText="upload" id="upload_icon" />
          </div>
          <div className="Icon_text">Drag and Drop the file to upload</div>
        </div>
        <input
          ref={this.fileBrowseRef}
          type="file"
          id="browseFile"
          style={{ display: "none" }}
          onChange={(e) => {
            this.onFilesAdded(e);
            e.target.value = "";
          }}
          multiple
          disabled={!!this.props.replaceFlag}
        />
        <button
          onClick={(e) => {
            this.fileBrowseRef.current && this.fileBrowseRef.current.click();
          }}
          className="browseBtn"
          disabled={this.props.disabled}
        >
          Browse file
        </button>
      </div>
    );
  }
}

export default Dropzone;
